// import ReactTyped from "react-typed";

import { useEffect, useState } from "react";
import ReactTyped from "react-typed";
import styles from "./styles.module.css";

const Typing = ({ landing_data, slide_index, setSlideIndex }) => {
  const [strings, setStrings] = useState([]);

  useEffect(() => {
    // extract the text from the landing_data
    const strings = landing_data.map((item) => item.carousel_text);
    setStrings(strings);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        // justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "max-content",
          padding: "0.05rem 0.2rem",
          position: "relative",
          height: "6rem",
          alignItems: "center",
        }}
        className={styles.typingContainer}
      >
        <ReactTyped
          strings={strings}
          typeSpeed={20}
          backSpeed={8}
          backDelay={5500}
          onStringTyped={(number) => setSlideIndex(number)}
          smartBackspace
          loop
          style={{
            fontSize: "2.2rem",
            zIndex: "2",
            color: "var(--text-color2)",
          }}
        />
        {/* <div
          style={{
            // background: 'red',
            background: "rgba(52, 155, 235, 0.2)",
            height: "50%",
            width: "100%",
            position: "absolute",
            top: "50%",
            left: "0",
            zIndex: "1",
          }}
        /> */}
      </div>
    </div>
  );
};

export default Typing;
